import { c as _c } from "react/compiler-runtime";
import request, { getErrorMessage } from '@onefootprint/request';
import type { GetProxyConfigsRequest, GetProxyConfigsResponse } from '@onefootprint/types';
import { useQuery } from '@tanstack/react-query';
import type { AuthHeaders } from '@/hooks/use-session';
import useSession from '@/hooks/use-session';
const getProxyConfigs = async (authHeaders: AuthHeaders, filters?: GetProxyConfigsRequest) => {
  const response = await request<GetProxyConfigsResponse>({
    method: 'GET',
    url: '/org/proxy_configs',
    headers: authHeaders,
    params: filters
  });
  return response.data;
};
const useProxyConfigs = filters => {
  const $ = _c(11);
  const {
    authHeaders
  } = useSession();
  let t0;
  if ($[0] !== authHeaders || $[1] !== filters) {
    t0 = {
      queryKey: ["proxy-configs", filters, authHeaders],
      queryFn: () => getProxyConfigs(authHeaders, filters)
    };
    $[0] = authHeaders;
    $[1] = filters;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const proxyConfigsQuery = useQuery(t0);
  const {
    error,
    data: t1
  } = proxyConfigsQuery;
  let t2;
  if ($[3] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const data = t2;
  let t3;
  if ($[5] !== error) {
    t3 = error ? getErrorMessage(error) : undefined;
    $[5] = error;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== data || $[8] !== proxyConfigsQuery || $[9] !== t3) {
    t4 = {
      ...proxyConfigsQuery,
      errorMessage: t3,
      data
    };
    $[7] = data;
    $[8] = proxyConfigsQuery;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default useProxyConfigs;